import { PackageLine } from '@freight-cbm/shared-types';
import { DemoDataset } from '@freight-cbm/shared-logic';
import { useAppStore } from '@/store/store';

export function loadDemo(demo: DemoDataset): void {
  let nextId = 1;
  const packages: PackageLine[] = demo.packages.map((p) => ({
    ...p,
    id: `demo-${nextId++}`,
  }));

  useAppStore.setState({
    packages,
    mode: demo.mode,
    dimDivisor: demo.dimDivisor,
    divisorOverridden: false,
    costInput: {
      ratePerKg: 0,
      ratePerCBM: 0,
      ratePerRevenueTon: 0,
      ratePerContainer: 0,
      accessorials: [],
      currency: 'USD',
      ...demo.costInput,
    },
  });
}
